import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { AcceptedConsentListDto } from '@/features/dashboard/clients/types/AcceptedConsentListDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { MissingRequiredConsentsDto } from '@/features/dashboard/bookings/types/MissingRequiredConsentsDto.ts';

const bookingAcceptedConsentsApi = {
  getTableDefinition: (bookingId: string): Promise<TableDefinitionDto> =>
    fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `bookings/${bookingId}/accepted-consents/table-definition`,
    ),
  getAll: (
    bookingId: string,
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<AcceptedConsentListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return fetchPrivateApi<PagedDto<AcceptedConsentListDto>>(
      'POST',
      `bookings/${bookingId}/accepted-consents/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getMissingRequired: (
    bookingId: string,
  ): Promise<MissingRequiredConsentsDto> =>
    fetchPrivateApi<MissingRequiredConsentsDto>(
      'GET',
      `bookings/${bookingId}/accepted-consents/missing-required`,
    ),
  requestSignature: (bookingId: string): Promise<void> =>
    fetchPrivateApi<void>(
      'POST',
      `bookings/${bookingId}/accepted-consents/request`,
    ),
};

export default bookingAcceptedConsentsApi;
